import { createAction } from 'typesafe-actions'

export const setTextFilter = createAction('CMD / ItemFilter / set text filter')<string>()

export const setTextFilterState = createAction('DOC / ItemFilter / set text filter state')<string>()
